import { getRedirectTo } from '@booking-portal/api/services/redirect-service';
import { useQuery } from '@tanstack/vue-query';

export function useRedirectToQuery() {
  return useQuery({
    queryKey: ['redirectTo'],
    queryFn: () => getRedirectTo(),
    staleTime: Infinity,
  });
}
